var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
		container: _vm.addContainerClass
	}},[_c('div',{staticClass:"bt"}),_c('div',{staticClass:"pt-150 pb-150"},[_c('FooterDisclaimer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }